import { Component } from '@angular/core';

/** Wraps every /admin/* route renders the persistent "Superadmin mode"
 *  banner once, above a <router-outlet> for the actual page, rather than
 *  repeating it on every admin page. Mirrors how Playground wraps its own
 *  child routes with a shared shell. */
@Component({
  selector: 'app-admin-layout',
  standalone: false,
  templateUrl: './admin-layout.html',
})
export class AdminLayout {}
